import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getInformacionInmaticCliente (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'tests') {
    return new Promise((resolve, reject) => {
      const data = mock.getCompanies
      const pages = data.data.length

      const clone = JSON.parse(JSON.stringify(data))
      clone.data = clone.data.slice(0, params.limit)

      clone.meta.total = pages

      resolve(clone)
    })
  } else {
    const req = {
      url: 'api/contabilidad/getconfiginmaticcliente',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getInformacionInmaticCliente }
